const $$splitNotFoundComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/roadmaps/$roadmapId/view/$viewId/table/index.tsx?tsr-split=notFoundComponent');
const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/roadmaps/$roadmapId/view/$viewId/table/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import i18n from '@/lib/translations/i18n';
import { saveLastVisitedVisualization } from '@/lib/utils/roadmapping/lastVisited';
export const Route = createFileRoute('/(app)/org/$org/roadmaps/$roadmapId/view/$viewId/table/')({
  loader: ({
    params
  }) => saveLastVisitedVisualization(Number(params.viewId), 'table'),
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  notFoundComponent: lazyRouteComponent($$splitNotFoundComponentImporter, 'notFoundComponent'),
  staticData: {
    topNav: {
      title: i18n.t('roadmaps.title')
    }
  }
});